module.exports = __webpack_public_path__ + "img/Aura_shinesparkle.c41c519b.png";